
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-32003b10!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Panel.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Panel.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-32003b10!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Panel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Panel.vue
// module id = 299
// module chunks = 0